

import React, { useLayoutEffect,useRef,useState } from 'react';
import LoginFun from './../../Layout Component/Loginfun';
import Swal from "sweetalert2";
import PreviousPregnancy from './PreviousPregnancyHull';
import 'react-toastify/dist/ReactToastify.css';
import SignatureCanvas from 'react-signature-canvas'
import moment from "moment";
import { setLoader } from "../../Store/Reducers/UserReducer"
import { useDispatch } from "react-redux";
export default function MedicalStep1Hull(props) {
debugger
    const { MedicalHistory, setMedicalHistory } = props;
    const logindata = LoginFun();
    const regex = /^[a-zA-Z0-9\s]*$/;
    let MainGender = localStorage.getItem("PatientGender");
    const padRef = useRef(null);
    const containerRef = useRef(null);
    const [canvasWidth, setCanvasWidth] = useState(360); // default
    const [canvasHeight, setCanvasHeight] = useState(300);
    const relatedContactData = JSON.parse(sessionStorage.getItem("ReleatedcontactData"));
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        var currentTime = ''
        currentTime = (Math.round(new Date().getTime() / 1000));
        var Expiretime = localStorage.getItem("ExpirretokenTime");
        if (Expiretime < currentTime) {
           dispatch(setLoader(false));
            sessionStorage.getItem('isLoggedIn', false)
            Swal.fire({
                title: 'Session Expired',
                text: "Your session has been expired! Please login again",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Okay',
            }).then(result => {
                logindata.logout();
            })
        }

          handleResize(); // initial
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize); 

     function handleResize() {
      debugger
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        setCanvasWidth(width); // match parent container width
        //setCanvasHeight(Math.round(width * 0.55)); // keep aspect ratio
      }
    }

    }, []);

    const updateMedicalHistory = (datas) => {

        setMedicalHistory(values => ({ ...values, [datas.target.name]: datas.target.value, 'id': MedicalHistory?.id }));
    }
 const updateMedicalhistory = (data) => {
    var name = data.target.name;
    var value = data.target.value;
    setMedicalHistory(values => ({ ...values, [name]: value, 'id': MedicalHistory?.id }));
  }

  // signature Changes 
  const clearSignatureCanvas = async () => {
    padRef?.current?.clear();
    var abc = null

    //localStorage.setItem("PAtientSignature", abc)
    setMedicalHistory({...MedicalHistory,patientsignatureTest: abc});

    //sessionStorage.setItem("PatientSignature", abc)
  };

  const formatIntoPng = () => {
    debugger
    var abc = padRef?.current?.toDataURL();
        const submittedDate = new Date().toISOString();
    setMedicalHistory({...MedicalHistory,patientsignatureTest: abc,submitteddateTest:submittedDate});
    //sessionStorage.setItem("PatientSignature", abc)
    
  };
// signature Changes END

    return (
      <>
      {MedicalHistory?.submitteddate && (
          <h5
            className="mb-3"
            style={{
              textAlign: "center",
              color: "red"
            }}
          >
            This form has already been signed and is now locked. No further changes can be made
          </h5>
      )}
        <div className='col-md-12 mt-3'>
            <div className=''>
               
                <div className="card rounded border"> 
                <div className="card-body row pt-3">
                <span className='fs-5 text-dark mb-3 mt-2'>SECTION A: Personal Details
                </span>

                 <div className='row mb-2'>
                    <div className='col-md-6'>
                        <div className='row '>
                        <div className='col-md-6'>
                            <label> How long have you been in this relationship?   </label>
                        </div>
                        <div className='col-md-6'>
                            <input type="text" placeholder="​​Please enter number of years​" className="form-control " name='lengthoftimewithyourcurrentpartner'
                            value={MedicalHistory?.lengthoftimewithyourcurrentpartner} onChange={(e) => { regex.test(e.target.value) && updateMedicalHistory(e) }} 
                            disabled={MedicalHistory?.submitteddate} />
                        </div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div className='row '>
                             {
                         MainGender === 1 || MainGender === "1" ? 
                        <div className='col-md-6'>
                            <label>How long have you been trying for a pregnancy? </label>
                        </div>  

                         : 
                         <div className='col-md-6'>
                            <label>How long have you been trying for a baby?  </label>
                        </div>

                        }
                        <div className='col-md-6'>
                            <input type="text" placeholder="​​Please enter number of years and months​" className="form-control " name='bcrm_forhowlonghaveyoubeentryingforapregnancy'
                            value={MedicalHistory?.bcrm_forhowlonghaveyoubeentryingforapregnancy} onChange={(e) => { regex.test(e.target.value) && updateMedicalHistory(e) }} 
                            disabled={MedicalHistory?.submitteddate} />
                        </div>
                        </div>
                    </div>
                 </div>

                <div className='row mb-2'>
                      <div className='col-md-6  '>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label>What is your weight? </label>
                            </div>
                            <div className='col-md-6'>
                                <input type="number" className="form-control "
                                    placeholder="​​Please enter your weight in Kg​"
                                    defaultValue={MedicalHistory?.weightinKilograms}
                                    name='weightinKilograms' onChange={(e) => updateMedicalHistory(e)} 
                                    disabled={MedicalHistory?.submitteddate}/>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-6 '>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label> What is your height?  </label>
                            </div>
                            <div className='col-md-6'>
                                <input type="number" className="form-control " placeholder="Enter height in meters "
                                    defaultValue={MedicalHistory?.heightinMetres}
                                    name='heightinMetres' onChange={(e) => updateMedicalHistory(e)} disabled={MedicalHistory?.submitteddate}/>
                                {MedicalHistory?.heightinMetres > 3 || MedicalHistory?.heightinMetres < 0 ? <span className='text-danger'> height field in meter should be in 0-3</span> : null
                                }

                            </div>
                        </div>
                    </div>
                </div>

                </div>
                </div>

                <div className="card rounded border mt-2"> 
                <div className="card-body row pt-3">
                <span className='fs-5 text-dark'>SECTION B: PARTNER DETAILS</span>
                 <span className='fs-10 text-dark mb-3 '><b>(Partner information is read-only)</b></span>

                 <div className='row mb-2'>
                    <div className='col-md-6'>
                        <div className='row '>
                        <div className='col-md-6'>
                            <label>Partner’s Name   </label>
                        </div>
                        <div className='col-md-6'>
                            <input type="text" className="form-control" 
                            value={relatedContactData?.fullname}
                            disabled
                            />
                        </div>
                        </div>
                    </div>
                    <div className='col-md-6  '>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label>Partner’s Date of Birth:  </label>
                            </div>
                            <div className='col-md-6'>
                                <input   type="date" disabled className="form-control "
                                    value={relatedContactData?.birthdate}
                                     />
                            </div>
                        </div>
                    </div>
                 </div>

                <div className='row mb-2'>
                    <div className='col-md-6 '>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label> Partner’s Address:  </label>
                            </div>
                            <div className='col-md-6'>
                                <textarea
                                value={relatedContactData?.address1_composite || ""}
                                disabled
                                rows={5}
                                style={{
                                    width: "100%",
                                    height: "130px",
                                    resize: "none"
                                }}
                            />
                                
                            </div>
                        </div>
                    </div>
                </div>

                </div>
                </div>

                 <div className="card rounded border mt-2"> 
                <div className="card-body row pt-3">
                <span className='fs-5 text-dark mb-3 mt-2'>SECTION C: PREVIOUS PREGNANCIES</span>
                     <div className="col-md-12">
                        <PreviousPregnancy checkTest={MedicalHistory?.submitteddate}/>
                    </div>
                </div>
                </div>

                 <div className="card rounded border mt-2">
              <div className="card-body row pt-3">
                <span className='fs-5 text-dark mb-3 mt-2'>SECTION D: GYNAECOLOGY HISTORY</span>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Have you ever used contraception?  </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='areyouCurrentlyUsingAnyContraceptives'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.areyouCurrentlyUsingAnyContraceptives}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            if (e.target.value === "271400001") { MedicalHistory.contraceptivesIfYesPleaseGiveDetails = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.areyouCurrentlyUsingAnyContraceptives === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.areyouCurrentlyUsingAnyContraceptives === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {MedicalHistory?.areyouCurrentlyUsingAnyContraceptives === 271400000 || MedicalHistory?.areyouCurrentlyUsingAnyContraceptives === "271400000" ?
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​Please provide details of contraception e.g. type (such as combined pill (e.g. Microgynon, Yasmin), mini pill, copper coil, Mirena coil, implant etc), when you used it, and if you had any problems </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" className="form-control "
                            placeholder="​​Please enter details here​"
                            name='contraceptivesIfYesPleaseGiveDetails'
                            value={MedicalHistory?.contraceptivesIfYesPleaseGiveDetails}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>

                        </div>
                      </div>
                    </div> : null}
                </div>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have periods? (If your answer is no, please move to Section C Question 11)</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='bcrm_doyouhaveperiods'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.bcrm_doyouhaveperiods}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.bcrm_doyouhaveperiods === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.bcrm_doyouhaveperiods === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <label>How many days do you bleed for? </label>
                      </div>
                      <div className='col-md-6'>
                        <input type="number" className="form-control" placeholder="​​Please enter details here​ " name='whatIsTheNormalLengthofBleedingDays'
                          defaultValue={MedicalHistory?.whatIsTheNormalLengthofBleedingDays} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}/>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <label>How frequently do you have a period (e.g. every 28 days, monthly, every 5–6 weeks, or irregular)</label>
                      </div>
                      <div className='col-md-6'>
                        <input type="text" placeholder="​Please enter details here​ " className="form-control " name='howLongAreYourCyclesDays'
                          value={MedicalHistory?.howLongAreYourCyclesDays} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate} />
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have painful periods?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='doYouSufferfromPainfulPeriodsDysmenorrhoea'
                          defaultValue={MedicalHistory?.doYouSufferfromPainfulPeriodsDysmenorrhoea} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.doYouSufferfromPainfulPeriodsDysmenorrhoea === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.doYouSufferfromPainfulPeriodsDysmenorrhoea === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have heavy periods?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='doYouSufferfromHeavyPeriodsMenorrhagia'
                          defaultValue={MedicalHistory?.doYouSufferfromHeavyPeriodsMenorrhagia} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.doYouSufferfromHeavyPeriodsMenorrhagia === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.doYouSufferfromHeavyPeriodsMenorrhagia === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have bleeding between periods?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='doYouHaveBleedingBetweenPeriods'
                          defaultValue={MedicalHistory?.doYouHaveBleedingBetweenPeriods} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                           <option value="271400001" selected={MedicalHistory?.doYouHaveBleedingBetweenPeriods === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.doYouHaveBleedingBetweenPeriods === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Have you had a cervical smear test?(If your answer is no, please move to Section D Question 12) </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example"
                          name='bcrm_haveyouhadacervicalsmeartest'
                          defaultValue={MedicalHistory?.bcrm_haveyouhadacervicalsmeartest}
                          onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                           <option value="271400001" selected={MedicalHistory?.bcrm_haveyouhadacervicalsmeartest === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.bcrm_haveyouhadacervicalsmeartest === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>What was the date of your last smear?</label>
                      </div>
                      <div className='col-md-6'>
                        <input type="Date" className="form-control " defaultValue={MedicalHistory?.whenWasYourLastSmearTest}
                      onChange={(e) => updateMedicalhistory(e)} name="whenWasYourLastSmearTest" />
                      </div>
                    </div>
                  </div>
                </div>


                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Have you ever had an abnormal cervical smear test?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example"
                          name="haveYouEverhadanAbnormalTest" defaultValue={MedicalHistory?.haveYouEverhadanAbnormalTest}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            if (e.target.value === "271400001") { MedicalHistory.hadanAbnormalTestifYesPleaseGiveDetails = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.haveYouEverhadanAbnormalTest === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.haveYouEverhadanAbnormalTest === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    {MedicalHistory?.haveYouEverhadanAbnormalTest === 271400000 || MedicalHistory?.haveYouEverhadanAbnormalTest === "271400000" ?
                      <div className='row '>
                        <div className='col-md-6'>
                          <label>​​Please provide details of any abnormal smears and treatment you have had here​ </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.hadanAbnormalTestifYesPleaseGiveDetails}
                            name="hadanAbnormalTestifYesPleaseGiveDetails" onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>
                        </div>
                      </div> : null}
                  </div>

                </div>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Have you ever suffered with pain during sex? </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.isintercoursepainfuldyspareunia}
                          name='isintercoursepainfuldyspareunia' onChange={(e) => {
                            if (e.target.value === "271400001") { MedicalHistory.dyspareuniaifyespleasegivedetails = ""; }
                            updateMedicalhistory(e);
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.isintercoursepainfuldyspareunia === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.isintercoursepainfuldyspareunia === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    {MedicalHistory?.isintercoursepainfuldyspareunia === 271400000 || MedicalHistory?.isintercoursepainfuldyspareunia === "271400000" ?
                      <div className='row '>
                        <div className='col-md-6'>
                          <label>If yes, please give details</label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.dyspareuniaifyespleasegivedetails}
                            name="dyspareuniaifyespleasegivedetails" onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>
                        </div>
                      </div> : null}
                  </div>
                </div>

                   <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Have been diagnosed with a condition called vaginismus before? </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" DefaultValue={MedicalHistory?.bcrm_havebeendiagnosedwithvaginismus}
                          name='bcrm_havebeendiagnosedwithvaginismus' onChange={(e) => {
                            if (e.target.value === "271400001") { MedicalHistory.bcrm_detailsofvaginismus = ""; }
                            updateMedicalhistory(e);
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.bcrm_havebeendiagnosedwithvaginismus === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.bcrm_havebeendiagnosedwithvaginismus === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
<div className='col-md-6'>
                    {MedicalHistory?.bcrm_havebeendiagnosedwithvaginismus === 271400000 || MedicalHistory?.bcrm_havebeendiagnosedwithvaginismus === "271400000" ?
                      <div className='row '>
                        <div className='col-md-6'>
                          <label>If yes, please give details</label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" placeholder="Enter detail" className="form-control " value={MedicalHistory?.bcrm_detailsofvaginismus}
                            name="bcrm_detailsofvaginismus" onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>
                        </div>
                      </div> : null}
                  </div>
                </div>

                <div className='row mb-2'>           
                   <div className='col-md-6'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <label>How frequently do you have intercourse?  
                          (e.g. per week / per month) </label>
                      </div>
                      <div className='col-md-6'>
                        <input type="number" placeholder="​Please enter details here​" className="form-control " name='bcrm_howmanytimeamonthdoyouhaveintercourse'
                          value={MedicalHistory?.bcrm_howmanytimeamonthdoyouhaveintercourse} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>

                      </div>
                    </div>
                  </div>

                   <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you bleed after sex?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='doYouExperienceBleedingAfterIntercourse'
                          defaultValue={MedicalHistory?.doYouExperienceBleedingAfterIntercourse} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.doYouExperienceBleedingAfterIntercourse === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.doYouExperienceBleedingAfterIntercourse === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>


                <div className='row mb-2'>

                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have excess hair growth on your face or body?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='bcrm_doyoufeelyouhavemorefacialhairthannormal'
                          defaultValue={MedicalHistory?.bcrm_doyoufeelyouhavemorefacialhairthannormal} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                             <option value="271400001" selected={MedicalHistory?.bcrm_doyoufeelyouhavemorefacialhairthannormal === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.bcrm_doyoufeelyouhavemorefacialhairthannormal === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have excess acne on your face or body?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='bcrm_doyoufrequentlygetspotsonyourface'
                          defaultValue={MedicalHistory?.bcrm_doyoufrequentlygetspotsonyourface} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                            <option value="271400001" selected={MedicalHistory?.bcrm_doyoufrequentlygetspotsonyourface === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.bcrm_doyoufrequentlygetspotsonyourface === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                </div>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have hot flushes or night sweats?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='bcrm_hotflushesnightsweats'
                          defaultValue={MedicalHistory?.bcrm_hotflushesnightsweats} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                           <option value="271400001" selected={MedicalHistory?.bcrm_hotflushesnightsweats === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.bcrm_hotflushesnightsweats === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                   <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Have you had fertility treatment in the past?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='haveYouEverHadAssistedConceptionTreatment'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.haveYouEverHadAssistedConceptionTreatment}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            if (e.target.value === "271400001") { MedicalHistory.contraceptivesIfYesPleaseGiveDetails = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.haveYouEverHadAssistedConceptionTreatment === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.haveYouEverHadAssistedConceptionTreatment === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  
                </div>

                <div className='row mb-2'>
                 
                  {MedicalHistory?.haveYouEverHadAssistedConceptionTreatment === 271400000 || MedicalHistory?.haveYouEverHadAssistedConceptionTreatment === "271400000" ?
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​​Please enter details about previous fertility treatment here​ </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" className="form-control "
                            placeholder="​​​Please enter details about previous fertility treatment here​ ​"
                            name='bcrm_assistedconceptiontreatmentdetails'
                            value={MedicalHistory?.bcrm_assistedconceptiontreatmentdetails}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>

                        </div>
                      </div>
                    </div> : null}

                      <div className='col-md-6'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <label>Have you had any of the following?
                          (Chronic pelvic pain, Polycystic ovary syndrome (PCOS), Endometriosis, Pelvic inflammatory disease, Sexually transmitted infection, Recurrent vaginal infections)</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" aria-label="Floating label select example" name='bcrm_haveyouhadanyofthefollowing'
                          defaultValue={MedicalHistory?.bcrm_haveyouhadanyofthefollowing} onChange={(e) => updateMedicalhistory(e)} disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          
                         <option value="271400000" selected={MedicalHistory?.bcrm_haveyouhadanyofthefollowing === 271400000}>Chronic pelvic pain</option>
                         <option value="271400001" selected={MedicalHistory?.bcrm_haveyouhadanyofthefollowing === 271400001}>Polycystic ovary syndrome (PCOS)</option>
                         <option value="271400002" selected={MedicalHistory?.bcrm_haveyouhadanyofthefollowing === 271400002}>Endometriosis</option>
                         <option value="271400003" selected={MedicalHistory?.bcrm_haveyouhadanyofthefollowing === 271400003}>Pelvic inflammatory disease</option>
                         <option value="271400004" selected={MedicalHistory?.bcrm_haveyouhadanyofthefollowing === 271400004}>Sexually transmitted infection</option>
                         <option value="271400005" selected={MedicalHistory?.bcrm_haveyouhadanyofthefollowing === 271400005}>Recurrent vaginal infections</option>

                        </select>
                      </div>
                    </div>
                  </div>
                    
                </div>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Have you had any of the following gynaecological operations e.g. removal of an ovarian cyst, removal of a fibroid?  </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='bcrm_haveyouhadanygynaecologicaloperation'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.bcrm_haveyouhadanygynaecologicaloperation}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            if (e.target.value === "271400001") { MedicalHistory.bcrm_detailsofgynaecologicaloperation = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.bcrm_haveyouhadanygynaecologicaloperation === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.bcrm_haveyouhadanygynaecologicaloperation === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {MedicalHistory?.bcrm_haveyouhadanygynaecologicaloperation === 271400000 || MedicalHistory?.bcrm_haveyouhadanygynaecologicaloperation === "271400000" ?
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​​Please enter details about any gynaecological surgery here​</label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" placeholder="​Please enter details here​ " className="form-control " name='bcrm_detailsofgynaecologicaloperation'
                            value={MedicalHistory?.bcrm_detailsofgynaecologicaloperation} onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>

                        </div>
                      </div>
                    </div> : null}
                </div>


              </div>
                 </div>

                 <div className="card rounded border mt-2">
              <div className="card-body row pt-3">
              <span className='fs-5 text-dark mb-3 mt-2'>SECTION E: MEDICAL AND SURGICAL HISTORY </span>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have or have you had any of the following(Heart murmur, Diabetes, Asthma, Mental health problems(e.g. anxiety, depression, schizophrenia, bipolar disease),
                          Raised blood pressure, Thyroid problems, Cancer, Deep vein thrombosis / pulmonary embolus, Large varicose veins )  </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='doYouHaveAnyMedicalConditionsEgAsthmae'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.doYouHaveAnyMedicalConditionsEgAsthmae}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            if (e.target.value === "271400001") { MedicalHistory.medicalconditionsifyespleaseprovidedetail = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.doYouHaveAnyMedicalConditionsEgAsthmae === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.doYouHaveAnyMedicalConditionsEgAsthmae === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {MedicalHistory?.doYouHaveAnyMedicalConditionsEgAsthmae === 271400000 || MedicalHistory?.doYouHaveAnyMedicalConditionsEgAsthmae === "271400000" ?
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​​Please enter details about medical problems here​ </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" className="form-control "
                            placeholder="​​Please enter details here​"
                            name='medicalconditionsifyespleaseprovidedetail'
                            value={MedicalHistory?.medicalconditionsifyespleaseprovidedetail}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>

                        </div>
                      </div>
                    </div> : null}
                </div>

                 <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Have you had any operations other than gynaecology surgery?</label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='haveyouhadanyoperations'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.haveyouhadanyoperations}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            if (e.target.value === "271400001") { MedicalHistory.bcrm_operationdetails = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.haveyouhadanyoperations === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.haveyouhadanyoperations === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {MedicalHistory?.haveyouhadanyoperations === 271400000 || MedicalHistory?.haveyouhadanyoperations === "271400000" ?
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​​​Please provide details about any operations here e.g. type of surgery, when you had the operation​ ​ </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" className="form-control "
                            placeholder="​​Please enter details here​"
                            name='bcrm_operationdetails'
                            value={MedicalHistory?.bcrm_operationdetails}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>

                        </div>
                      </div>
                    </div> : null}
                </div>

                  <div className='row mb-2'>
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​​ Any Other Medical History​ ​ </label>
                        </div>
                        <div className='col-md-6'>
                          <textarea className="form-control"
                            placeholder="​​Please enter details here​"
                            name='furtherInformationIfYesPleaseProvideDetails'
                            value={MedicalHistory?.furtherInformationIfYesPleaseProvideDetails}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>
                        </div>
                      </div>
                    </div>
                </div>


                </div>
                </div>

                <div className="card rounded border mt-2">
                <div className="card-body row pt-3">
                <span className='fs-5 text-dark mb-3 mt-2'>SECTION F: VACCINATION HISTORY </span>

                    <div className='row mb-2'>
                      <div className='col-md-6'>
                        <div className='row '>
                        <div className='col-md-6'>
                            <label>Covid vaccination status </label>
                        </div>
                        <div className='col-md-6'>
                            <select className="form-select " id="floatingSelect" name='bcrm_covidvaccinationstatus'
                            aria-label="Floating label select example" defaultValue={MedicalHistory?.bcrm_covidvaccinationstatus}
                            onChange={(e) => {
                                updateMedicalhistory(e);
                            } } disabled={MedicalHistory?.submitteddate}>
                            <option>--Select--</option>
                            <option value="271400000" selected={MedicalHistory?.bcrm_covidvaccinationstatus === 271400000}>I am fully vaccinated</option>
                            <option value="271400001" selected={MedicalHistory?.bcrm_covidvaccinationstatus === 271400001}>I am not vaccinated </option>
                            <option value="271400002" selected={MedicalHistory?.bcrm_covidvaccinationstatus === 271400002}>Other</option>
                            </select>
                        </div>
                        </div>
                    </div>

                    {MedicalHistory?.bcrm_covidvaccinationstatus === 271400002 || MedicalHistory?.bcrm_covidvaccinationstatus === "271400002" ?
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>Please provide details here​ </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" className="form-control "
                            placeholder="​​Please enter details here​"
                            name='bcrm_covidvaccinationdetails'
                            value={MedicalHistory?.bcrm_covidvaccinationdetails}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>

                        </div>
                      </div>
                    </div> 
                    : null}
                    </div>

                    <div className='row mb-2'>
                      <div className='col-md-6'>
                        <div className='row '>
                        <div className='col-md-6'>
                            <label>Rubella vaccination status</label>
                        </div>
                        <div className='col-md-6'>
                            <select className="form-select " id="floatingSelect" name='bcrm_rubellavaccinationstatus'
                            aria-label="Floating label select example" defaultValue={MedicalHistory?.bcrm_rubellavaccinationstatus}
                            onChange={(e) => {
                                updateMedicalhistory(e);
                            } } disabled={MedicalHistory?.submitteddate}>
                            <option>--Select--</option>
                            <option value="271400000" selected={MedicalHistory?.bcrm_rubellavaccinationstatus === 271400000}>I have been tested and am immune to Rubella</option>
                            <option value="271400001" selected={MedicalHistory?.bcrm_rubellavaccinationstatus === 271400001}>I have been tested and am NOT immune to Rubella </option>
                            <option value="271400002" selected={MedicalHistory?.bcrm_rubellavaccinationstatus === 271400002}>I have had all my childhood vaccinations and/or received 2 MMR vaccinations</option>
                            <option value="271400003" selected={MedicalHistory?.bcrm_rubellavaccinationstatus === 271400003}>I do not know if I have had any vaccinations and have not been tested</option>
                            </select>
                        </div>
                        </div>
                    </div>
                    </div>

                </div>
                </div>

                 <div className="card rounded border mt-2">
              <div className="card-body row pt-3">
              <span className='fs-5 text-dark mb-3 mt-2'>SECTION G: MEDICATIONS HISTORY </span>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do you have any drug allergies? </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='areYouAllergicToAnyMedication'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.areYouAllergicToAnyMedication}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            if (e.target.value === "271400001") { MedicalHistory.allergictoMedicationIfYesGivedetail = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                         <option value="271400001" selected={MedicalHistory?.areYouAllergicToAnyMedication === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.areYouAllergicToAnyMedication === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {MedicalHistory?.areYouAllergicToAnyMedication === 271400000 || MedicalHistory?.areYouAllergicToAnyMedication === "271400000" ?
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​​Please provide details about any drug allergies here​ ​ </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" className="form-control "
                            placeholder="​​Please enter details here​"
                            name='allergictoMedicationIfYesGivedetail'
                            value={MedicalHistory?.allergictoMedicationIfYesGivedetail}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate}/>

                        </div>
                      </div>
                    </div> 
                    : null}
                </div>

                 <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Are you taking any regular medications (prescribed and over the counter), including vitamins and supplements? </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='areyoutakinganyMedicationsCurrently'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.areyoutakinganyMedicationsCurrently}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            if (e.target.value === "271400001") { MedicalHistory.takingAnyMedicationsIfYesPleaseGiveDetail = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                         <option value="271400001" selected={MedicalHistory?.areyoutakinganyMedicationsCurrently === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.areyoutakinganyMedicationsCurrently === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {MedicalHistory?.areyoutakinganyMedicationsCurrently === 271400000 || MedicalHistory?.areyoutakinganyMedicationsCurrently === "271400000" ?
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​​​Please provide details about any medications here​ ​ ​ </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" className="form-control "
                            placeholder="​​Please enter details here​"
                            name='takingAnyMedicationsIfYesPleaseGiveDetail'
                            value={MedicalHistory?.takingAnyMedicationsIfYesPleaseGiveDetail}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate} />

                        </div>
                      </div>
                    </div> 
                    : null}
                </div>

              </div>
              </div>


             <div className="card rounded border mt-2">
              <div className="card-body row pt-3">
              <span className='fs-5 text-dark mb-3 mt-2'>SECTION H: FAMILY HISTORY </span>

                <div className='row mb-2'>
                  <div className='col-md-6'>
                    <div className='row '>
                      <div className='col-md-6'>
                        <label>Do any of the following illnesses or genetic conditions in first degree relatives (e.g. parents, siblings, children). 
                          <br></br>
                           Genetic Disorder (e.g. cystic fibrosis, thalassaemia, Down syndrome),
                           Birth defect (e.g. heart defect), 
                           Cancers,
                           Deep vein thrombosis / Pulmonary embolus,
                           Blood disorders,
                           Polycystic ovary syndrome (PCOS) ,
                           Diabetes,
                           Endometriosis,
                           Early menopause,
                           Infertility,
                           Recurrent miscarriages (3 or more)
                           </label>
                      </div>
                      <div className='col-md-6'>
                        <select className="form-select " id="floatingSelect" name='doyouHaveaFamilyHistoryofMedicalConditions'
                          aria-label="Floating label select example" defaultValue={MedicalHistory?.doyouHaveaFamilyHistoryofMedicalConditions}
                          onChange={(e) => {
                            updateMedicalhistory(e);
                            // if (e.target.value === "271400001") { MedicalHistory.familyHistoryMedicalIfYesPleaseGiveDetail = ""; }
                          } } disabled={MedicalHistory?.submitteddate}>
                          <option>--Select--</option>
                          <option value="271400001" selected={MedicalHistory?.doyouHaveaFamilyHistoryofMedicalConditions === 271400001}>No</option>
                          <option value="271400000" selected={MedicalHistory?.doyouHaveaFamilyHistoryofMedicalConditions === 271400000}>Yes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                 {/* {MedicalHistory?.doyouHaveaFamilyHistoryofMedicalConditions === 271400000 || MedicalHistory?.doyouHaveaFamilyHistoryofMedicalConditions === "271400000" ? */}
                    <div className='col-md-6'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <label>​​Please provide details about any family medical problems here​  </label>
                        </div>
                        <div className='col-md-6'>
                          <input type="text" className="form-control "
                            placeholder="​​Please enter details here​"
                            name='familyHistoryMedicalIfYesPleaseGiveDetail'
                            value={MedicalHistory?.familyHistoryMedicalIfYesPleaseGiveDetail}
                            onChange={(e) => { regex.test(e.target.value) && updateMedicalhistory(e); } } disabled={MedicalHistory?.submitteddate} />

                        </div>
                      </div>
                    </div> 
                    {/* : null} */}
                </div>

              </div>
              </div>

                <div className="card rounded border mt-2"> 
                <div className="card-body row pt-3">
                 <span className='fs-5 text-dark mb-3 mt-2'>SECTION I: SOCIAL HISTORY</span>

                 <div className='row mb-2'>
                    <div className='col-md-6'>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label >Do you smoke cigarettes? </label>
                            </div>
                            <div className='col-md-6'>
                                <select className="form-select " id="floatingSelect" name='doYouSmoke'
                                    aria-label="Floating label select example" defaultValue={MedicalHistory?.doYouSmoke}
                                    onChange={(e) => {
                                        updateMedicalHistory(e)
                                        if (e.target.value === "271400001") { MedicalHistory.smokeIfYesIndicateHowManyPerDay = "" }
                                    }} disabled={MedicalHistory?.submitteddate}>
                                    <option >--Select--</option>
                                    <option value="271400001" selected={MedicalHistory?.doYouSmoke === 271400001}>No</option>
                                    <option value="271400000" selected={MedicalHistory?.doYouSmoke === 271400000}>Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    {MedicalHistory?.doYouSmoke === 271400000 || MedicalHistory?.doYouSmoke === "271400000" ?
                        <div className='col-md-6'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <label >​​Please provide details about how many cigarettes you smoke</label>
                                </div>
                                <div className='col-md-6'>
                                    <input type="text" className="form-control "
                                        placeholder="​​Please provide details about how many cigarettes you smoke ​ "
                                        name='smokeIfYesIndicateHowManyPerDay'
                                        value={MedicalHistory?.smokeIfYesIndicateHowManyPerDay}
                                        onChange={(e) => { regex.test(e.target.value) && updateMedicalHistory(e) }} disabled={MedicalHistory?.submitteddate}/>

                                </div>
                            </div>
                        </div> : null}
                </div>

                 <div className='row mb-2'>
                    <div className='col-md-6'>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label >Have you smoked in the last 6 months?  </label>
                            </div>
                            <div className='col-md-6'>
                                <select className="form-select " id="floatingSelect" name='bcrm_haveyousmokedinthelast6months'
                                    aria-label="Floating label select example" defaultValue={MedicalHistory?.bcrm_haveyousmokedinthelast6months}
                                    onChange={(e) => {
                                        updateMedicalHistory(e)
                                    }} disabled={MedicalHistory?.submitteddate}>
                                    <option >--Select--</option>
                                    <option value="271400001" selected={MedicalHistory?.bcrm_haveyousmokedinthelast6months === 271400001}>No</option>
                                    <option value="271400000" selected={MedicalHistory?.bcrm_haveyousmokedinthelast6months === 271400000}>Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-6'>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label >Do you vape?</label>
                            </div>
                            <div className='col-md-6'>
                                <select className="form-select " id="floatingSelect" name='bcrm_doyouvape'
                                    aria-label="Floating label select example" defaultValue={MedicalHistory?.bcrm_doyouvape}
                                    onChange={(e) => {
                                        updateMedicalHistory(e)
                                    }} disabled={MedicalHistory?.submitteddate}>
                                    <option >--Select--</option>
                                    <option value="271400001" selected={MedicalHistory?.bcrm_doyouvape === 271400001}>No</option>
                                    <option value="271400000" selected={MedicalHistory?.bcrm_doyouvape === 271400000}>Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    
                </div>

                 <div className='row mb-2'>
                    <div className='col-md-6'>
                        <div className='row '>
                            <div className='col-md-6'>
                            <label >How many units of alcohol do you drink in a week (1 standard glass of wine = 1 unit | 1 bottle of wine = 10 units | 1 pint lager/beer/cider (normal strength) = 2 units | 1 shot of a spirit = 1 unit) </label>
                            </div>
                            <div className='col-md-6'>
                                <input type="text" className="form-control " placeholder="​​Units of alcohol​"
                                        value={MedicalHistory?.alcoholIfYesHowManyUnitsPerWeek}
                                        name='alcoholIfYesHowManyUnitsPerWeek'
                                        onChange={(e) => { regex.test(e.target.value) && updateMedicalHistory(e) }} disabled={MedicalHistory?.submitteddate}/>
                            </div>
                        </div>
                    </div>

                     <div className='col-md-6'>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label >Have you used any recreational drugs in the past 5 years?</label>
                            </div>
                            <div className='col-md-6'>
                                <select className="form-select " id="floatingSelect"
                                    aria-label="Floating label select example"
                                    name='doYouUseReCreationalDrugs' defaultValue={MedicalHistory?.doYouUseReCreationalDrugs}
                                    onChange={(e) => {
                                        updateMedicalHistory(e)
                                    }} disabled={MedicalHistory?.submitteddate}>
                                    <option >--Select--</option>
                                    <option value="271400001" selected={MedicalHistory?.doYouUseReCreationalDrugs === 271400001}>No</option>
                                    <option value="271400000" selected={MedicalHistory?.doYouUseReCreationalDrugs === 271400000}>Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div className='row mb-2'>
                    <div className='col-md-6'>
                        <div className='row '>
                            <div className='col-md-6'>
                            <label>How many hours of exercise do you do in a week? </label>
                            </div>
                            <div className='col-md-6'>
                                <input type="number" className="form-control" placeholder="​​​Hours of exercise​ ​"
                                        value={MedicalHistory?.bcrm_exercisehoursweek}
                                        name='bcrm_exercisehoursweek'
                                        onChange={(e) => { regex.test(e.target.value) && updateMedicalHistory(e) }} disabled={MedicalHistory?.submitteddate}/>
                            </div>
                        </div>
                    </div>

                     <div className='col-md-6'>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label >Do you have a disability?</label>
                            </div>
                            <div className='col-md-6'>
                                <select className="form-select " id="floatingSelect"
                                    aria-label="Floating label select example"
                                    name='isThePatientDisabled'
                                    value={MedicalHistory?.isThePatientDisabled}
                                    onChange={(e) => {
                                        if (e.target.value === "271400001") { MedicalHistory.isThePatientDisabledifYesPleaseGiveDetail = "" }
                                        updateMedicalHistory(e)
                                    }} disabled={MedicalHistory?.submitteddate}>
                                    {/* <option value="0">--Select--</option> */}
                                    <option>--Select--</option>
                                    <option value='271400001' selected={MedicalHistory?.isThePatientDisabled === 271400001}>No</option>
                                    <option value='271400000' selected={MedicalHistory?.isThePatientDisabled === 271400000}>Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>
 
                    </div>
                    

                <div className='row mb-2'>
                   {MedicalHistory?.isThePatientDisabled === 271400000 || MedicalHistory?.isThePatientDisabled === '271400000' ?
                        <div className='col-md-6'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <label >If yes, please give details</label>
                                </div>
                                <div className='col-md-6'>
                                    <input type="text" className="form-control " placeholder="Enter detail" value={MedicalHistory?.isThePatientDisabledifYesPleaseGiveDetail} name='isThePatientDisabledifYesPleaseGiveDetail'
                                        onChange={(e) => { regex.test(e.target.value) && updateMedicalHistory(e) }} disabled={MedicalHistory?.submitteddate}/>
                                </div>
                            </div>
                        </div>
                        :
                        null
                    }

                     <div className='col-md-6'>
                        <div className='row '>
                            <div className='col-md-6'>
                                <label>Have you travelled area effected by Zika or Ebola virus in last 6 month</label>
                            </div>
                            <div className='col-md-6'>
                                <select className="form-select " id="floatingSelect"
                                    aria-label="Floating label select example"
                                    name='bcrm_haveyoutravelledareaeffectedbyzikaorebola' defaultValue={MedicalHistory?.bcrm_haveyoutravelledareaeffectedbyzikaorebola}
                                    onChange={(e) => {
                                        updateMedicalHistory(e)
                                        if (e.target.value === "271400001") { MedicalHistory.bcrm_detailsforsteroidsforbodybuilding = "" }
                                    }} disabled={MedicalHistory?.submitteddate}>
                                    <option >--Select--</option>
                                    <option value="271400000" selected={MedicalHistory?.bcrm_haveyoutravelledareaeffectedbyzikaorebola === 271400000}>Yes</option>
                                    <option value="271400001" selected={MedicalHistory?.bcrm_haveyoutravelledareaeffectedbyzikaorebola === 271400001}>No</option>
                                    <option value="271400002" selected={MedicalHistory?.bcrm_haveyoutravelledareaeffectedbyzikaorebola === 271400002}>I don't know</option>
                                    
                                </select>
                            </div>
                        </div>
                    </div>

                </div>

                    {
                        MainGender === 1 || MainGender === "1" ?
                    <div className='row mb-2'>
                                                <>
                                                <div className='col-md-6'>
                                                <div className='row'>
                                                <div className='col-md-6'>
                                                    <label >Do you use or have you ever used steroids for body building?</label>
                                                </div>
                                                <div className='col-md-6'>
                                                    <select className="form-select " id="floatingSelect"
                                                        aria-label="Floating label select example"
                                                        name='bcrm_usedsteroidsforbodybuilding' defaultValue={MedicalHistory?.bcrm_usedsteroidsforbodybuilding}
                                                        onChange={(e) => {
                                                            updateMedicalHistory(e)
                                                            if (e.target.value === "271400001") { MedicalHistory.bcrm_detailsforsteroidsforbodybuilding = "" }
                                                        }} disabled={MedicalHistory?.submitteddate}>
                                                        <option >--Select--</option>
                                                        <option value="271400001" selected={MedicalHistory?.bcrm_usedsteroidsforbodybuilding === 271400001}>No</option>
                                                        <option value="271400000" selected={MedicalHistory?.bcrm_usedsteroidsforbodybuilding === 271400000}>Yes</option>
                                                    </select>
                                                </div>
                                                </div>
                                                </div>
                                                </>
                                            
                                    {(MedicalHistory?.bcrm_usedsteroidsforbodybuilding === 271400000 || MedicalHistory?.bcrm_usedsteroidsforbodybuilding === "271400000")
                                        ?
                                        <div className='col-md-6'>
                                            <div className='row '>
                                                <div className='col-md-6'>
                                                <label>​​Please provide details​</label>
                                                </div>
                                                <div className='col-md-6'>
                                                    <input type="text" className="form-control" placeholder="​​​​Please provide details​​"
                                                            value={MedicalHistory?.bcrm_detailsforsteroidsforbodybuilding}
                                                            name='bcrm_detailsforsteroidsforbodybuilding'
                                                            onChange={(e) => { regex.test(e.target.value) && updateMedicalHistory(e) }} disabled={MedicalHistory?.submitteddate}/>
                                                </div>
                                            </div>
                                        </div>:null
                                        }
                    </div>
                        :null
                    } 
                </div>
                </div>

                  <div className="card rounded border mt-2">
                          <div className="card-body row pt-3">
                          <span className='fs-5 text-dark mb-3 mt-2'>SECTION J: Welfare of child self declaration</span>

                          <div className='row mb-2'>
                            <b>The Code of Practice issued by the Human Fertilization and Embryology Authority requires that, prior to providing assisted conception treatment, 
                              the treatment centre is responsible for making suitable enquiries about the welfare of the child/ children who may be born following such treatment 
                              (including the need of supportive parenting), and of any other child who may be affected by the birth.</b>
                          </div>

                          <div className='row mb-2'>
                              <b className='mb-2'>We are asking you if there is any reason that you may be aware of why it may not be appropriate to offer you fertility treatment.</b>
                          </div>

                          <div className='row mb-2'>
                            <b>Please answer the following statements:</b>
                          </div>

            <div className='container'>
                        <div className="card rounded border mt-2">
                          <div className="card-body">
                            <div className='row mb-2'>
                              <b>I declare that I have been named in a case related to</b>
                            </div>

                              <div className='row mb-2'>
                                <div className='col-md-6'>
                                  <div className='row '>
                                    <div className='col-md-6'>
                                      <label>The safeguarding of a child <span className="required"></span> : </label>
                                    </div>
                                    <div className='col-md-6'>
                                      <select className="form-select " id="floatingSelect" name='thesafeguardingofachild'
                                        aria-label="Floating label select example" defaultValue={MedicalHistory?.thesafeguardingofachild}
                                        onChange={(e) => {
                                          updateMedicalhistory(e);
                                        } } disabled={MedicalHistory?.submitteddate}>
                                        <option value="0">--Select--</option>
                                        <option value="271400000" selected={MedicalHistory?.thesafeguardingofachild === 271400000}>Yes</option>
                                        <option value="271400001" selected={MedicalHistory?.thesafeguardingofachild === 271400001}>No</option>
                                      </select>
                                      
                                    </div>
                                  </div>
                                </div>
                                  <div className='col-md-6'>
                                    <div className='row'>
                                      <div className='col-md-6'>
                                        <label>Domestic abuse or neglect <span className="required"></span> : </label>
                                      </div>
                                      <div className='col-md-6'>

                                      <select className="form-select " id="floatingSelect" name='domesticabuseorneglect'
                                        aria-label="Floating label select example" defaultValue={MedicalHistory?.domesticabuseorneglect}
                                        onChange={(e) => {
                                          updateMedicalhistory(e);
                                        } } disabled={MedicalHistory?.submitteddate}>
                                        <option value="0">--Select--</option>
                                        <option value="271400000" selected={MedicalHistory?.domesticabuseorneglect === 271400000}>Yes</option>
                                        <option value="271400001" selected={MedicalHistory?.domesticabuseorneglect === 271400001}>No</option>
                                    
                                      </select>

                                      </div>
                                    </div>
                                  </div> 
                              </div>

                        </div>
                      </div>
            </div>
            <div className='container'>
                    <div className="card rounded border mt-2">
                          <div className="card-body">
                            <div className='row mb-2'>
                              <b>I declare that I am recovering from</b>
                            </div>

                              <div className='row mb-2'>
                                <div className='col-md-6'>
                                  <div className='row '>
                                    <div className='col-md-6'>
                                      <label>Drug addiction <span className="required"></span> :</label>
                                    </div>
                                    <div className='col-md-6'>
                                      <select className="form-select " id="floatingSelect" name='drugaddiction'
                                        aria-label="Floating label select example" defaultValue={MedicalHistory?.drugaddiction}
                                        onChange={(e) => {
                                          updateMedicalhistory(e);
                                        } } disabled={MedicalHistory?.submitteddate}>
                                        <option value="0">--Select--</option>
                                        <option value="271400000" selected={MedicalHistory?.drugaddiction === 271400000}>Yes</option>
                                        <option value="271400001" selected={MedicalHistory?.drugaddiction === 271400001}>No</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                  <div className='col-md-6'>
                                    <div className='row'>
                                      <div className='col-md-6'>
                                        <label>Alcohol addiction <span className="required"></span> : </label>
                                      </div>
                                      <div className='col-md-6'>

                                      <select className="form-select " id="floatingSelect" name='alcoholaddiction'
                                        aria-label="Floating label select example" defaultValue={MedicalHistory?.alcoholaddiction}
                                        onChange={(e) => {
                                          updateMedicalhistory(e);
                                        } } disabled={MedicalHistory?.submitteddate}>
                                        <option value="0">--Select--</option>
                                        <option value="271400000" selected={MedicalHistory?.alcoholaddiction === 271400000}>Yes</option>
                                        <option value="271400001" selected={MedicalHistory?.alcoholaddiction === 271400001}>No</option>
                                        
                                      </select>

                                      </div>
                                    </div>
                                  </div> 
                              </div>
                              
                        </div>
                      </div>
            </div>

            <div className='container'>
              <div className="card rounded border mt-2">
                          <div className="card-body">

                              <div className='row mb-2'>
                                <div className='col-md-6'>
                                  <div className='row '>
                                    <div className='col-md-6'>
                                      <label>I declare that I have had a criminal conviction(s) <span className="required"></span> : </label>
                                    </div>
                                    <div className='col-md-6'>
                                      <select className="form-select " id="floatingSelect" name='ideclarethatihavehadacriminalconviction'
                                        aria-label="Floating label select example" defaultValue={MedicalHistory?.ideclarethatihavehadacriminalconviction}
                                        onChange={(e) => {
                                          updateMedicalhistory(e);
                                        } } disabled={MedicalHistory?.submitteddate}>
                                        <option value="0">--Select--</option>
                                        <option value="271400000" selected={MedicalHistory?.ideclarethatihavehadacriminalconviction === 271400000}>Yes</option>
                                        <option value="271400001" selected={MedicalHistory?.ideclarethatihavehadacriminalconviction === 271400001}>No</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                  <div className='col-md-6'>
                                    <div className='row'>
                                      <div className='col-md-6'>
                                        <label>I declare that I have suffered from significant mental ill-health <span className="required"></span> :</label>
                                      </div>
                                      <div className='col-md-6'>

                                      <select className="form-select " id="floatingSelect" name='ideclarethatihavesufferedfromsignificantm'
                                        aria-label="Floating label select example" defaultValue={MedicalHistory?.ideclarethatihavesufferedfromsignificantm}
                                        onChange={(e) => {
                                          updateMedicalhistory(e);
                                        } } disabled={MedicalHistory?.submitteddate}>
                                        <option value="0">--Select--</option>
                                        <option value="271400000" selected={MedicalHistory?.ideclarethatihavesufferedfromsignificantm === 271400000}>Yes</option>
                                        <option value="271400001" selected={MedicalHistory?.ideclarethatihavesufferedfromsignificantm === 271400001}>No</option>
                                      </select>

                                      </div>
                                    </div>
                                  </div> 
                              </div>
                              
                        </div>
                      </div>
                      </div>


              <div className='row mt-2'>
                            <b>Any questions answered ‘yes’ will be explored in your confidential face to face consultation and may require deeper investigation.
                              It does not necessarily mean that treatment will not be able to proceed after further enquiry.
                              Treatment may be declined if it becomes apparent that information has been concealed.</b>
                          </div>

                          </div>
                          </div>

                
{/* PATINENT SIGNATURE  Female*/}
              <div className="card rounded border mt-2">
              <div className="card-body row pt-3">
              <span className='fs-5 text-dark mb-3 mt-2'> </span>

                              <div className='row mb-2'>
                                <div className='col-md-12'>
                                  <div className='row '>
                                    <div className='col-md-4'>
                                      <label>I confirm and take responsibility for the information, I have enter on the form <span className="required"></span> : </label>
                                    </div>
{MedicalHistory?.patientsignature ? (
    // Existing signature
    <div className="col-md-8">
      <strong>Form already signed on :- {moment(MedicalHistory.submitteddate).format("DD-MMM-YYYY")}</strong><br></br>

                <img
                    src={MedicalHistory.patientsignature}
                    alt="Patient signature"
                    style={{
                        maxWidth: "300px",
                        height: "100px",
                        objectFit: "contain"
                    }}
                />
    </div>
) : (
    // No signature - show Signature Canvas
    <div className="col-md-8">
        <div className="form-floating" ref={containerRef}>
            <label htmlFor="SignaturePAD">Signature</label>
            <div style={{ border: "1px solid" }}>
                <SignatureCanvas
                    id="SignaturePAD"
                    ref={padRef}
                    penColor="green"
                    canvasProps={{
                        className: "sigCanvas",
                        width: canvasWidth,
                        height: 300,
                        style: {
                            width: `${canvasWidth}px`,
                            height: "300px"
                        }
                    }}
                    onEnd={formatIntoPng}
                />
            </div>

            <br />

            {/* <button
                type="button"
                onClick={clearSignatureCanvas}
            > */}

              <button
    type="button"
    className="btn btn-outline-secondary btn-sm"
    onClick={clearSignatureCanvas}
    style={{ width: "80px" }}
>
    Clear
</button>
               
        </div>
    </div>
)}
                                   
                                  </div>
                                </div>
                              </div>
              </div>
              </div>
{/* PATINENT SIGNATURE END*/}
<br></br>

             
            </div>
            <br></br>
        </div>
        </>
    )
}
